import { jsx as _jsx } from "react/jsx-runtime";
import { Editor_DiseaseValue } from '../../../Editor_DiseaseValue/Editor_DiseaseValue.js';
import './Editor_MultiVar_Values.scss';
import { FadeScrollWrapper } from '@app/styles';
import { AwaitModules } from '@nu-art/thunderstorm-frontend';
import { ModuleFE_Expression, ModuleFE_Value, ModuleFE_Variable } from '@app/hcs-frontend';
export const Editor_MultiVar_Values = (props) => {
    return _jsx(FadeScrollWrapper, { className: 'e__multi-var__values', children: props.diseaseValues.map((dv, index) => {
            return _jsx(AwaitModules, { modules: [ModuleFE_Expression, ModuleFE_Variable, ModuleFE_Value], children: _jsx(Editor_DiseaseValue, { diseaseValue: dv, editMode: props.editMode, showSourceEditor: props.showSourceEditor }) }, dv._id ?? `clean-${index}`);
        }) });
};
//# sourceMappingURL=Editor_MultiVar_Values.js.map